jQuery(document).ready(function ($) {
    const imageOverlaySlider = new Swiper('.js-image-overlay-gallery', {
        loop: true,

        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },

        slidesPerView: 1,
        speed: 1000,

        navigation: {
            nextEl: '.js-image-overlay-gallery__arrow--next',
            prevEl: '.js-image-overlay-gallery__arrow--prev'
        },

        autoplay: {
            delay: 5000
        }
    })
});